import styled, {DefaultTheme, StyledComponentProps} from 'styled-components';
import {ITypography, Typography} from './typography';
import {
  getFontSizeFromTheme,
  getFontWeightFromTheme,
  getLineHeightFromTheme,
} from '../../ui-utils';

export type Headline2Props = StyledComponentProps<
  'h2',
  DefaultTheme,
  ITypography,
  'kind' | 'align'
>;

/**
 Use to display higher hierarchical content
 **/
export const Headline2 = styled.h2<ITypography>`
  ${Typography};

  font-size: ${getFontSizeFromTheme('headline2')};
  font-weight: ${getFontWeightFromTheme('bold')};
  line-height: ${getLineHeightFromTheme('headline2')};
`;
